import { Box } from '../box';
import { EllipsisText } from '../ellipsis-text';
import { Flex } from '../flex';
import { styled } from '../theme';

export interface PageHeaderProps {
  title: string;
  endAdornment?: React.ReactNode;
  subtitleSection?: React.ReactNode;
  linkAdornment?: React.ReactNode;
  tabs?: JSX.Element;
}

const HeaderWrapper = styled(Flex, {
  shouldForwardProp: (prop) => prop !== 'withBottomPadding',
})<{ withBottomPadding: boolean }>(({ theme, withBottomPadding }) => ({
  padding: withBottomPadding ? theme.spacing(6) : theme.spacing(6, 6, 0),
  width: '100%',
  flexDirection: 'column',
  gap: theme.spacing(3),
  backgroundColor: theme.palette.background.paper,
  alignItems: 'flex-start',
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
}));

// TODO: Rename this styled component
const MainContainer = styled(Flex)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(2),
  width: '100%',
}));

export default function PageHeader(props: Readonly<PageHeaderProps>) {
  const { title, endAdornment, subtitleSection, linkAdornment, tabs } = props;

  const withBottomPadding = !tabs;

  return (
    <HeaderWrapper withBottomPadding={withBottomPadding}>
      {linkAdornment ? <Box>{linkAdornment}</Box> : null}
      <MainContainer>
        <Flex
          sx={{
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            width: '100%',
            gap: (theme) => theme.spacing(6),
          }}
        >
          {/* NOTE: We use the `h1` variant for the title text because it is the highest level of heading text. */}
          <EllipsisText
            data-testid='page-header-title-text'
            variant='h2'
            maxLines={2}
            component='h1'
            sx={{ flexGrow: 1, wordBreak: 'break-word' }}
          >
            {title}
          </EllipsisText>
          <Flex
            sx={{ alignItems: 'center', minWidth: 'fit-content', gap: (theme) => theme.spacing(4) }}
          >
            {endAdornment}
          </Flex>
        </Flex>

        {subtitleSection ? (
          <Flex
            sx={{
              gap: (theme) => theme.spacing(6),
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
            }}
          >
            {subtitleSection}
          </Flex>
        ) : null}
      </MainContainer>
      {tabs ? <Box sx={{ width: '100%' }}>{tabs}</Box> : null}
    </HeaderWrapper>
  );
}
